/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const ReceiptsPage = lazyLoad(
  () => import('./index'),
  module => module.ReceiptsPage
);
